import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
  disabled:PropTypes.any
};

export default function RHFTextField({ disabled,name, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField  disabled={disabled} {...field} fullWidth error={!!error} helperText={error?.message} {...other} />
      )}
    />
  );
}
